export default __webpack_public_path__ + "static/media/image-placeholder.ddc70ffb.svg";